import React, { useContext, useEffect, useRef, useState } from "react";

import { ReactComponent as Personal } from "../../assets/icons/personal.svg";
import { ReactComponent as Business } from "../../assets/icons/business.svg";
import { ReactComponent as Close } from "../../assets/icons/x.svg";
import { ReactComponent as Check } from "../../assets/icons/check.svg";
import { Loader } from "react-feather";
import ReactDOM from "react-dom";
import AccountCreated from "./AccountCreated";
import { NotificationContext } from "../../Context/NotificationContext";
import { AuthContext } from "../../Context/AuthContext";
import { FormTextInput } from "../../Components/FormTextInput";
import "./CreateAccount.css";
import { AccountType, EAST4 } from "../../utility/enums";
import { auth, firestore, getFullHttpUrl } from "../../firebase.config";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { getQueryParam, useScreenTransition } from "../../Hooks/useScreenTransition";
import { HowDidYouHearAboutUs, updateHowDidYouHearData } from "../../Data/Functions/HowDidYouHear";
import { v4 as uuidv4 } from "uuid";

export default function CreateAccount({
  open,
  isCreateAccountOpen,
  isLoginFormOpen,
  showSelectAccountType = true,
  accountType = "personal",
  width = "792px",
}) {
  const modalRoot = document.getElementById("modal-root");
  const [userInf, setUserInf] = useState({
    firstName: "",
    lastName: "",
    companyName: "",
    email: "",
    password: "",
  });

  const [accoutTypeSelected, setAccountTypeSelected] = useState(accountType);
  const [accountStatus, setAccountStatus] = useState("not-created");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassError, setShowPassError] = useState(false);
  const { showNotification } = useContext(NotificationContext);
  const [submitButton, setSubmitButton] = useState("Create an Account");
  const { setSignedIn } = useContext(AuthContext);
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [marketingCampaignData, setMarketingCampaignData] = useState(null);
  const { signedIn } = useContext(AuthContext);
  const { transitionTo } = useScreenTransition();
  const now = new Date();
  const localMarketingData = JSON.parse(localStorage.getItem("marketingCampaignData"));
  const localMarketingId = localMarketingData ? localMarketingData.isValid > now.getTime() && localMarketingData.id : null;
  const marketingCampaignId= getQueryParam("business")?? localMarketingId;
  const createAccountParam= getQueryParam("create-account");
  const joinTeamParam= getQueryParam("join-team");
  const joinTeamToken= getQueryParam("token");

  const [joinTeamData, setJoinTeamData] = useState(null);

  const [selectedOption, setSelectedOption] = useState("");
  const [showInputOption, setShowInputOption] = useState(false);
  const [optionInput, setOptionInput] = useState("");

  const inputRef = useRef(null);


  const closeModel = () => {
    isCreateAccountOpen(false);
    setEmailError(false);
    setPasswordError(false);
    setShowPassError(false);
    setIsLoading(false);
  };

  const openLoginForm = () => {
    isCreateAccountOpen(false);
    isLoginFormOpen(true);
  };

  const closeAccountCreated = () => {
    setAccountStatus("not-created");
    isCreateAccountOpen(false);
  };

  const updateMarketingCampaign = async (marketingampaignId) => {
    const marketingCampaignRef = firestore.collection("marketingCampaigns").doc(marketingampaignId);
    const docRef = await marketingCampaignRef.get();
    if(docRef.exists && docRef.data().active){
      const data = docRef.data();
      setMarketingCampaignData({...data, id: docRef.id});
    }
  }


  const getTeamData = async(joinTeamToken) => {
    const teamRef = await firestore.collection("teams").doc(joinTeamToken).get();
    if(teamRef.exists){
      const teamData = teamRef.data();
      setJoinTeamData({...teamData, id: teamRef.id});
      setUserInf({...userInf, companyName: teamData.name});
    }
  }


  useEffect(() => {
    if(!signedIn){
      if(joinTeamParam && joinTeamToken){
        setAccountTypeSelected("business");
        getTeamData(joinTeamToken);
      }
      if(marketingCampaignId && !joinTeamParam){
        setAccountTypeSelected("business");
        updateMarketingCampaign(marketingCampaignId);
        const date = new Date();
        date.setDate(date.getDate() + 7);
        const timeAfter7Days = date.getTime();
        console.log(timeAfter7Days)
        localStorage.setItem("marketingCampaignData", JSON.stringify({id: marketingCampaignId, isValid: timeAfter7Days}));
      }
      if(createAccountParam === "true"){
        isCreateAccountOpen(true);
        isLoginFormOpen(false);
        
      }

    }
  }, [signedIn])

  const createUser = async(selectedType = "personal", isTeam = false) => {
    try {
      await auth.createUserWithEmailAndPassword(
          userInf.email.toLowerCase(),
          userInf.password
        )
        .then(async (credential) => {

          if(selectedType === "personal"){
            
            const howDidYouHear = {selectedOption: selectedOption??"", hasInput: showInputOption??false, inputText: optionInput??""};

            updateHowDidYouHearData(credential?.user?.uid, howDidYouHear, userInf.email, userInf.firstName + " " + userInf.lastName, "",credential?.user?.uid);
          }

          const teamData = joinTeamParam && joinTeamToken ? joinTeamData : isTeam ? await createTeam() : null;

          const userDetails = {
            role: AccountType.CLIENT,
            name: userInf.firstName + " " + userInf.lastName,
            email: userInf.email.toLowerCase(),
            firstName: userInf.firstName,
            lastName: userInf.lastName,
            timestamp: new Date().getTime(),
          }

          const userDetailswithTeam = {
            hasTeam: true,
            teamId: teamData ? teamData.id : "",
            teamJoinTimestamp: new Date().getTime(),
            teamRole: joinTeamParam && joinTeamToken ? "member" : "owner",
            teamStatus: "active",
            ...userDetails
          }

          // console.log("userDetails====>>>>>>>", userDetails);

          const docRef = firestore.collection("users").doc(credential.user.uid);

          await docRef.set(isTeam ? userDetailswithTeam : userDetails);

          if(isTeam && teamData && marketingCampaignData){
            axios.post(getFullHttpUrl("updateMarketingCampaign", EAST4), {
              id: marketingCampaignData.id,
              teamId: teamData.id,
              teamName: teamData.name
            })
  
            localStorage.removeItem("marketingCampaignData");
          }

          setAccountStatus("created");
          transitionTo("/account/team-members");

          setSignedIn(true);
          showNotification(
            "Success",
            "Your account has been created!",
            "success"
          );

          // await axios.post(
          //   getFullHttpUrl("onUserSignup"),
          //   {
          //     uid: credential.user.uid,
          //   }
          // );
        });
    } catch (error) {
      setIsLoading(false);
      setSubmitButton("Create an Account");
      console.log("error====>>>>>>>", error);
      var errorCode = error.code;

      switch (errorCode) {
        case "auth/email-already-in-use":
          showNotification(
            "Email Already in Use",
            "The email is already in use. Please, try another one.",
            "error"
          );
          break;
        case "auth/invalid-email":
          showNotification(
            "Invalid Email",
            "The email address is invalid. Please, try again.",
            "error"
          );
          break;
        case "auth/weak-password":
          showNotification(
            "Weak Password",
            "The password is too weak. Please, try again.",
            "error"
          );
          break;
        default:
          showNotification(
            "Error",
            "An unexpected error occurred. Please, try again.",
            "error"
          );
      }
    } finally {
      setSubmitButton("Create an Account");
    }
  }

  const createPersonalAccount = async () => {
    if (userInf.email === "" || !/\S+@\S+\.\S+/.test(userInf.email)) {
      setEmailError(true);
      return;
    }

    if (userInf.password === "" || userInf.password.length < 6) {
      setPasswordError(true);
      return;
    }

    setSubmitButton("Creating...");
    setIsLoading(true);

    createUser(accoutTypeSelected);
  };

  const triggerPersonalAccount = () => {
    if (
      accoutTypeSelected === "personal" &&
      !(
        userInf.firstName === "" ||
        userInf.lastName === "" ||
        userInf.email === "" ||
        userInf.password === "" ||
        userInf.password.length < 6
      )
    ) {
      createPersonalAccount();
    }
  };

  const createTeam = async() => {
    const teamData = {
      name: userInf.companyName,
      discount: marketingCampaignData?.discount || 0,
      freeExpeditedOrders: marketingCampaignData?.freeExpeditedOrders || 0,
      expeditedServices: marketingCampaignData?.freeExpeditedOrders ? "free-plus" : "paid",
      lastInvoiceTimestamp: new Date().getTime(),
      orderPlacedNotifyToAll: false,
      orderCompletedNotifyToAll: false,
      quotePlacedNotifyToAll: false,
      quoteReadyNotifyToAll: false,
      status:'Active',
      timestamp: new Date().getTime(),
      shipping: [],
      newTeam: true,
      isCreatedByMarketingCampaign: marketingCampaignData ? true : false,
      billingTerm : "case-by-case",
      billingPeriod: null,
    }
    const teamRef = await firestore.collection("teams").add(teamData);

    return {...teamData, id: teamRef.id};
  }

  const createBusinessAccount = async () => {
    if (userInf.email === "" || !/\S+@\S+\.\S+/.test(userInf.email)) {
      setEmailError(true);
      return;
    }

    if (userInf.password === "" || userInf.password.length < 6) {
      setPasswordError(true);
      return;
    }

    setSubmitButton("Creating");
    setIsLoading(true);

    createUser(accoutTypeSelected, true);
  };

  const triggerBusinessAccount = () => {
    if (
      accoutTypeSelected === "business" &&
      !(
        userInf.firstName === "" ||
        userInf.companyName === ""
      )
    ) {
      createBusinessAccount();
    }else{
      showNotification("Error", "Please fill first name or company name.", "error");
    }
  };

  const handleEmailBlur = () => {
    if (userInf.email === "" || !/\S+@\S+\.\S+/.test(userInf.email)) {
      setEmailError(true);
    }
  };

  const handlePasswordBlur = () => {
    if (userInf.password === "" || userInf.password.length < 6) {
      setPasswordError(true);
    }
    setShowPassError(true);
  };

  const isBtnDisabled =
    accoutTypeSelected === "personal"
      ? !userInf.firstName || !userInf.lastName ||
      !userInf.email ||
      !userInf.password
      : !userInf.firstName || !userInf.lastName ||
      !userInf.companyName ||
      !userInf.email ||
      !userInf.password;

  if (!open) return null;

  const handleValueChange = (value, name) => {
    if (name === "email") {
      setEmailError(false);
    }

    if (name === "password") {
      setPasswordError(false);
    }
    setUserInf((prev) => ({ ...prev, [name]: value }));
  };

  const onClickOption = (option) => {
    setSelectedOption(option.value);
    setShowInputOption(option.extraInput??false);
    setOptionInput("");
    inputRef.current && inputRef.current.focus();
  }

  return ReactDOM.createPortal(
    <div className="modal">
      <div className="modal-content"></div>
      {accountStatus === "not-created" ? (
        <div
          className={`createAccountForm mx-[16px] w-[90%] max-w-[${width ? width : "792px"}] max-h-[90%] overflow-y-auto`}
        >
          <div
            className={`createAccountFormHeader ${
              !showSelectAccountType && "mb-2"
            }`}
          >
            {!showSelectAccountType && accountType === "business" ? (
              <h2 className="createAccountFormTitle">
                Create a Business Account
              </h2>
            ) : !showSelectAccountType && accountType === "personal" ? (
              <h2 className="createAccountFormTitle">
                Create a Personal Account
              </h2>
            ) : (
              showSelectAccountType && (
                <h2 className="createAccountFormTitle">Create Account</h2>
              )
            )}
            <Close
              className="createAccountCloseIcon"
              onClick={() => closeModel()}
            />
          </div>

          {showSelectAccountType && (
            <h3 className="createAccountFormSpan">Select Account Type</h3>
          )}
          <div
            className={
              showSelectAccountType ? "createAccountFormContainerAdd" : ""
            }
          >
            {showSelectAccountType && (
              <div className="createAccountFormAccountType">
                <div
                  className={
                    accoutTypeSelected === "personal"
                      ? "createAccountFormTypeOption chosenAccountBorder"
                      : "createAccountFormTypeOption" + (joinTeamParam && joinTeamToken ? " opacity-50" : "")
                  }
                  onClick={() => joinTeamParam && joinTeamToken ? "": setAccountTypeSelected("personal")}
                >
                  <div className="createAccountFormTypeOptionHead">
                    <Personal className="personalIcon" />
                    <h3 className="createAccountFormTypeOptionHeadTitle">
                      Personal
                    </h3>
                  </div>
                  <span className="createAccountFormTypeOptionSpan">
                    Ideal for individuals who make one or more orders
                  </span>
                </div>

                <div
                  className={
                    accoutTypeSelected === "business"
                      ? "createAccountFormTypeOption chosenAccountBorder"
                      : "createAccountFormTypeOption"
                  }
                  onClick={() => setAccountTypeSelected("business")}
                >
                  <div className="createAccountFormTypeOptionHead">
                    <Business className="personalIcon" />
                    <h3 className="createAccountFormTypeOptionHeadTitle">
                      Business
                    </h3>
                  </div>
                  <span className="createAccountFormTypeOptionSpan">
                    Ideal for long-term customers and businesses
                  </span>

                  <div
                    className="createAccountFormTypeOptionListItem"
                    style={{ marginTop: 10 }}
                  >
                    <Check className="createAccountFormTypeOptionListItemIcon" />
                    <span className="createAccountFormTypeOptionListItemText">
                      Add personal clients to the order
                    </span>
                  </div>

                  <div className="createAccountFormTypeOptionListItem">
                    <Check className="createAccountFormTypeOptionListItemIcon" />
                    <span className="createAccountFormTypeOptionListItemText">
                      Create a team
                    </span>
                  </div>

                  <div className="createAccountFormTypeOptionListItem">
                    <Check className="createAccountFormTypeOptionListItemIcon" />
                    <span className="createAccountFormTypeOptionListItemText">
                      Pay for orders at a time convenient for you
                    </span>
                  </div>
                </div>
              </div>
            )}

            <div className="createAccountFormContainerAddingForm">
              <div className="signInFormContainer">
                <FormTextInput
                  email={false}
                  incorrect={false}
                  placeholder={"First Name"}
                  clearInputIcon={false}
                  value={userInf?.firstName}
                  name={"firstName"}
                  onChange={handleValueChange}
                  // onKeyDown={(e) =>
                  //   e.key === "Enter" && accoutTypeSelected === "personal"
                  //     ? triggerPersonalAccount()
                  //     : createBusinessAccount()
                  // }
                />
              </div>

              <div className="signInFormContainer">
                <FormTextInput
                  email={false}
                  incorrect={false}
                  placeholder={"Last Name"}
                  clearInputIcon={false}
                  value={userInf?.lastName}
                  name={"lastName"}
                  onChange={handleValueChange}
                  // onKeyDown={(e) =>
                  //   e.key === "Enter" && accoutTypeSelected === "personal"
                  //     ? triggerPersonalAccount()
                  //     : createBusinessAccount()
                  // }
                />
              </div>

              {(accountType === "business" ||
                accoutTypeSelected === "business") && (
                <div className="signInFormContainer">
                  <FormTextInput
                    email={false}
                    incorrect={false}
                    placeholder={"Company Name"}
                    clearInputIcon={false}
                    value={userInf?.companyName}
                    name={"companyName"}
                    disabled={joinTeamParam && joinTeamToken && userInf.companyName !== ""}
                    onChange={handleValueChange}
                    // onKeyDown={(e) =>
                    //   e.key === "Enter" && accoutTypeSelected === "personal"
                    //     ? triggerPersonalAccount()
                    //     : createBusinessAccount()
                    // }
                  />
                </div>
              )}

              <div className="signInFormContainer">
                <FormTextInput
                  email={true}
                  incorrect={emailError}
                  placeholder={"Email"}
                  clearInputIcon={true}
                  onBlur={handleEmailBlur}
                  value={userInf?.email}
                  name={"email"}
                  onChange={handleValueChange}
                  // onKeyDown={(e) =>
                  //   e.key === "Enter" && accoutTypeSelected === "personal"
                  //     ? triggerPersonalAccount()
                  //     : createBusinessAccount()
                  // }
                />
              </div>

              {emailError ? (
                <div className="RegisterFormInputValidation">
                  Invalid email format. Example: example@example.com
                </div>
              ) : null}

              <div className="signInFormContainer">
                <FormTextInput
                  showPasswordIcon={true}
                  password={true}
                  incorrect={passwordError}
                  placeholder={"Password"}
                  onBlur={handlePasswordBlur}
                  value={userInf?.password}
                  name={"password"}
                  onChange={handleValueChange}
                  // onKeyDown={(e) =>
                  //   e.key === "Enter" && accoutTypeSelected === "personal"
                  //     ? triggerPersonalAccount()
                  //     : createBusinessAccount()
                  // }
                />
              </div>

              {showPassError && (
                <span
                  className={`passwordValidation ${
                    passwordError
                      ? "passwordError"
                      : userInf?.password.length >= 6
                      ? "passwordSuccess"
                      : "passwordDefault"
                  }`}
                >
                  <Check className="passwordCheck" />
                  At least 6 characters
                </span>
              )}

            {!signedIn && accoutTypeSelected === "personal" && 
              <div className="mt-4">
                <h4 className="quotePrimaryTitle">How did you hear about us?</h4>
                <div className='flex flex-wrap gap-[8px] mt-4'>
                  {HowDidYouHearAboutUs.map((option, i) => 
                     <div key={option.value} className={`relative flex justify-start items-center gap-2 min-w-[70px] overflow-hidden transition-all duration-300
                      bg-[#fff] rounded-[8px] ${showInputOption && selectedOption === option.value  ? "px-[16px] pt-[16px] pb-[8px]" : "px-[16px] py-[16px]"} cursor-pointer hover:border-[#12ABBF]  min-h-[54px]
                      ${selectedOption === option.value ? 'border-[#12ABBF] border-[2px] ' : 'border-[#E6E7E9] border-[1px]'} "w-max" max-sm:w-full`} onClick={() => onClickOption(option)}>
                         {option.icon && <img src={option.icon} alt={""} className='w-[24px] h-[24px]'/> }
                         <p className={`${showInputOption && selectedOption === option.value ? `transition-all duration-300 absolute text-[#686f7b] ${selectedOption === option.value ? "text-[12px] weight-[400] top-[4px] left-[8px]" : "top-[18px] left-[16px] onBoarding-description text-[12px]"}` : "onBoarding-description text-[12px]"}`}>
                          {option.label}
                          </p> 
                          {showInputOption && selectedOption === option.value && 
                          <input ref={inputRef} type="text" autoFocus className={`${i === 4 ? "w-[218px]": i === 5 ? "w-[287px]" : "w-full"} min-w-[160px] h-[18px] border-[0] outline-none bg-transparent text-[14px] weight-[400]`} placeholder={option.extraInputLabel?? "Please specify"} value={optionInput} onChange={(e) => setOptionInput(e.target.value)} onClick={(e) => e.stopPropagation()}/>
                        }
                    </div>
                  )}
                </div>
              </div>
              }

              <div className="SubmitForm">
                <button
                  className="SubmitFormButton"
                  disabled={isBtnDisabled || isLoading || passwordError || (accoutTypeSelected === "personal" && (selectedOption === "" || (selectedOption === "other" && optionInput === "")))}
                  onClick={() =>
                    accoutTypeSelected === "personal"
                      ? triggerPersonalAccount()
                      : triggerBusinessAccount()
                  }
                  onKeyDown={(e) =>
                    e.key === "Enter" &&
                    accoutTypeSelected === "personal"
                      ? triggerPersonalAccount()
                      : triggerBusinessAccount()
                  }
                >
                  {submitButton}
                  {isLoading && <Loader className="btnLoader" />}
                </button>
              </div>

              <div className="RegisterToHaveSignIn">
                <span className="RegisterToHaveSignInText">
                  If you have an account
                </span>
                <span
                  className="RegisterToHaveSignInSpan"
                  onClick={() => openLoginForm()}
                >
                  Sign In
                </span>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {accountStatus === "created" ? (
        <AccountCreated
          closeAccountCreated={closeAccountCreated}
          accoutTypeSelected={accoutTypeSelected}
        />
      ) : null}
    </div>,
    modalRoot
  );
}
